/**
 * Created by Mikhail Menshenin on 04.06.2025
 */

Placements.ENTRIES["showLevelMastery"] = {
    type: Placements.INTERMEDIATE,
    filter: function () {
        return cleverapps.environment.isMainScene()
            && cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY);
    },
    action: function () {
        cleverapps.missionManager.trigger("addLevelMasteryBar");
    }
};

Placements.ENTRIES["levelMasteryRewardCollect"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,
    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY);
        return mission && mission.logic.isStageCompleted();
    },
    action: function () {
        cleverapps.missionManager.trigger("levelMasteryRewardCollect");
    }
};
